import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: '"Era escéptico total. Había probado todo: apps, terapia, incluso medicación. Este método fue lo único que funcionó de verdad. La primera noche con el ejercicio 4-4-6 dormí 7 horas seguidas por primera vez en meses."',
  name: 'Carlos M.',
  city: 'Houston, TX',
  avatar: 'https://cdn.magicpatterns.com/uploads/ivqmMdJbCahM6QQYR7Kyhc/ca75331a-f1f9-461d-9d3b-e1839e67a86e.png'
}, {
  quote: '"No soy una persona "espiritual" ni creo en cosas alternativas. Soy ingeniera y necesito que las cosas tengan lógica. Este método tiene sentido: trabaja con el cuerpo, no solo con la mente. Y funciona."',
  name: 'Laura S.',
  city: 'Miami, FL',
  avatar: 'https://cdn.magicpatterns.com/uploads/oNGCLJDWHb35f15vvGnYNf/71ac0537-2d6a-4b85-b76e-de09967d446e.png'
}, {
  quote: '"Como madre de dos niños pequeños, no tengo tiempo para rutinas largas. 15 minutos antes de dormir han cambiado completamente mi calidad de sueño. Ahora tengo energía para disfrutar de mis hijos en vez de solo sobrevivir."',
  name: 'Ana R.',
  city: 'Los Angeles, CA',
  avatar: 'https://cdn.magicpatterns.com/uploads/ga7M4Tr8fcUD9jmuSWhk3W/download_(81).png'
}, {
  quote: '"Después de un burnout laboral, mi sistema nervioso estaba destrozado. Probé meditación pero no podía concentrarme. Estas técnicas somáticas no requieren concentración mental, y eso fue la clave para mí."',
  name: 'Roberto F.',
  city: 'Chicago, IL',
  avatar: 'https://cdn.magicpatterns.com/uploads/5qF7RcbYBdh5zgWRNCimgs/Realistic_masculine_avatar_202512152004.jpg'
}, {
  quote: '"Llevaba años con ansiedad crónica. Lo que más me sorprendió fue notar cambios físicos reales en 3-4 días: menos tensión en la mandíbula, mejor digestión, y finalmente pude dormir sin despertarme a las 3 AM."',
  name: 'Patricia G.',
  city: 'New York, NY',
  avatar: 'https://cdn.magicpatterns.com/uploads/8MuYZZAHE78Tg68fQSpFQE/assets_task_01jypnjc29e0xatna7g9qe0dd3_1750960155_img_1.webp'
}, {
  quote: '"Pensé \'otro método más que no va a funcionar\'. Pero me convenció la garantía de 30 días. A la semana ya estaba durmiendo mejor. Al mes, mi pareja notó que estaba menos irritable. Vale cada centavo."',
  name: 'Miguel A.',
  city: 'Phoenix, AZ',
  avatar: 'https://cdn.magicpatterns.com/uploads/5G6Xzp1khQaZQ8QY5mDERc/Gemini_Generated_Image_qy5fflqy5fflqy5f.png'
}];
function Stars() {
  return <div className="flex gap-1 mb-4" data-id="element-253">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-gold text-amber-gold" data-id="element-254" />)}
    </div>;
}
export function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full px-6 py-10" data-id="element-255">
      <div className="max-w-5xl mx-auto" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-257">
          {/* Header */}
          <div className="text-center mb-10" data-id="element-258">
            <p className="text-amber-gold font-bold text-lg md:text-xl mb-1" data-id="element-259">
              4.9/5 — Valoración promedio
            </p>
            <p className="text-warm-cream/50 text-sm mb-6" data-id="element-260">
              Basado en testimonios verificados
            </p>
            <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-3" data-id="element-261">
              Lo que dicen personas escépticas como tú
            </h2>
            <p className="text-warm-cream/70 text-lg" data-id="element-262">
              Ninguno creía que funcionaría. Todos habían probado otras cosas
              antes.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-263">
            {testimonials.map((t, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-warm-cream/5 border border-warm-cream/10 rounded-xl p-6 flex flex-col" data-id="element-264">
                <Stars data-id="element-265" />
                <p className="text-warm-cream/85 text-sm md:text-base leading-relaxed flex-1" data-id="element-266">
                  {t.quote}
                </p>
                <div className="border-t border-warm-cream/10 mt-5 pt-4 flex items-center gap-3" data-id="element-267">
                  {t.avatar ? <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover flex-shrink-0" data-id="element-268" /> : <div className="w-10 h-10 rounded-full bg-amber-gold flex items-center justify-center flex-shrink-0" data-id="element-269">
                      <span className="text-dark-navy font-bold text-sm" data-id="element-270">
                        {t.name.split(' ').map(n => n[0]).join('')}
                      </span>
                    </div>}
                  <div data-id="element-271">
                    <p className="font-semibold text-sm" data-id="element-272">{t.name}</p>
                    <p className="text-warm-cream/50 text-xs" data-id="element-273">{t.city}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}